import { render, staticRenderFns } from "./payoutList.vue?vue&type=template&id=ed24ee3c"
import script from "./payoutList.vue?vue&type=script&lang=ts"
export * from "./payoutList.vue?vue&type=script&lang=ts"
import style0 from "./payoutList.vue?vue&type=style&index=0&id=ed24ee3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports